import Unit from '@leverege/unit';
import Util from "../Util.js";
export default {
  create: molten => {
    const types = Unit.getUnitTypes();
    types.forEach(type => {
      molten.addPlugin('ImagineHistoryComparatorFilterConverter', {
        id: `molten.${type}.LessThan.ComparatorFilterConverter`,
        type: `${type}.LessThan`,
        convert
      });
    });
  }
};
function convert(cmp, attribute) {
  let value1 = cmp.value1;
  if (value1 == null) {
    return null;
  }
  if (value1 != null && value1.unit) {
    if (attribute.baseUnit && value1.unit !== attribute.baseUnit) {
      value1 = Unit.convert(value1.value, value1.unit, attribute.baseUnit);
    } else {
      value1 = value1.value;
    }
  }
  const comparator = cmp.includesValue1 ? '<=' : '<';
  const field = Util.getHistoryFieldFromField(attribute.blueprint.field);
  return Util.createSingleComparatorFilter(value1, comparator, field);
}